import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const TicketAddIcon = React.memo(function TicketAddIcon(props: TTicketAddIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Create Ticket" {...props}>
            <path
                clipRule="evenodd"
                fillRule="evenodd"
                d="m1.013 7.18 15.525-4.16.813 3.118a3.073 3.073 0 0 0-1.215 3.302c.076.293.192.564.34.81h-.328c-.437 0-.841.147-1.164.393a4.597 4.597 0 0 1 .688-4.997l-.205-.786L2.84 8.244l.205.786a4.519 4.519 0 0 1 2.896 3.142 4.588 4.588 0 0 1-.985 4.181l.205.787 7.089-1.9v.111c0 .504.194.962.51 1.305l-8.67 2.323-.813-3.117a3.073 3.073 0 0 0 1.215-3.302 3.023 3.023 0 0 0-2.666-2.262L1.013 7.18Zm18.315 6.796a.173.173 0 0 1 .172.172v1.204a.172.172 0 0 1-.172.171h-1.805v1.805a.172.172 0 0 1-.171.172h-1.204a.172.172 0 0 1-.171-.172v-1.804h-1.805a.173.173 0 0 1-.172-.172v-1.204c0-.094.077-.171.172-.171h1.805v-1.805a.172.172 0 0 1 .172-.172h1.203c.094 0 .171.077.171.172v1.805h1.805Z"
            />
        </IconBase>
    );
});

export default TicketAddIcon;

// #region Types

export type TTicketAddIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <TicketAddIcon /> : { ...IconBaseExample, render: TicketAddIcon };

// #endregion
